module.exports = __webpack_public_path__ + "img/fernando-viviani-byn.2fedbee9.jpg";